import { IPagination, IPaginationDTO } from '@/models/pagination.model';

/** Admin blog posts list sorting (query: `sort` / `direction`). */
export type BlogPostListSortField = 'created_at' | 'published_at' | 'published' | 'is_pinned';

export type BlogPostListSortDirection = 'asc' | 'desc';

export enum BlogPostEndpoints {
  BLOG_POSTS = '/blog/posts',
  BLOG_POST = '/blog/post',
  BLOG_CATEGORIES = '/blog/categories',
  BLOG_MEDIA = '/blog/media',
}

/** Laravel `blog-posts` list item (BlogPostListResource). */
export interface IBlogPostListItem {
  id: string;
  published: boolean;
  is_draft?: boolean;
  is_pinned: boolean;
  cover_image?: string | null;
  published_at?: string | null;
  blog_category?: {
    id: string;
    name?: string;
    slug?: string;
    position?: number;
  } | null;
  author?: {
    id: string;
    full_name?: string;
    first_name?: string;
    last_name?: string;
  } | null;
  locale: Record<string, { name: string; slug: string }>;
  created_at?: string;
  updated_at?: string;
}

export interface IBlogLocaleContentDetail {
  name: string;
  slug: string;
  description?: string | null;
  cover_image_alt?: string | null;
  content?: IBlogContentBlockApi[] | null;
}

export interface IBlogContentBlockApi {
  type: string;
  position: number;
  data: Record<string, unknown> | unknown[];
}

/** Blog category row from GET /blog/categories (BlogCategoryResource). */
export interface IBlogCategoryListItem {
  id: string;
  position: number;
  locale: Record<string, { name?: string | null; slug?: string | null }>;
}

export interface IBlogCategoriesListResponse {
  data: IBlogCategoryListItem[];
}

/** Laravel blog post detail (BlogPostResource). */
export interface IBlogPostDetail {
  id: string;
  blog_post_id?: string;
  category?: {
    id: string;
    slug: string;
    name: Record<string, string | null | undefined>;
  } | null;
  blog_category?: {
    id: string;
    name?: string;
    slug?: string;
    position?: number;
  } | null;
  cover_image?: string | null;
  is_published?: boolean;
  is_draft?: boolean;
  published_at?: string | null;
  is_pinned: boolean;
  locale: Record<string, IBlogLocaleContentDetail>;
  created_at?: string;
  updated_at?: string;
}

export interface IBlogPostsListResponse {
  data: IBlogPostListItem[];
  meta: IPagination;
}

export interface IBlogPostDetailResponse {
  data: IBlogPostDetail;
}

/** POST /blog/media (BlogMediaController). */
export interface IBlogMediaUploadResponse {
  data: {
    url: string;
  };
}

export interface IBlogPostListQueryDTO extends Partial<IPaginationDTO> {
  page?: number;
  per_page?: number;
  blog_category_id?: string;
  /** Title / post name search */
  search?: string;
  search_id?: string;
  search_author?: string;
  sort?: BlogPostListSortField;
  direction?: BlogPostListSortDirection;
}

/** Body for POST/PATCH blog post (matches BlogPostStoreRequest / BlogPostUpdateRequest). */
export interface IBlogPostStorePayload {
  category_id?: string | null;
  blog_category_id?: string | null;
  cover_image?: string | null;
  is_pinned: boolean;
  locale: Record<
    string,
    {
      name: string;
      slug: string | null;
      description?: string | null;
      cover_image_alt?: string | null;
      content?: IBlogContentBlockApi[] | null;
    }
  >;
}

export const CONTENT_PAGE_CREATE_ID = 'create';
